angular.module("galilai.creator").controller("PostgenController", function ($scope, api, $timeout, $interval, $rootScope, transcribeService) {
    $scope.step = 1;
    $scope.activeIndex = null;
    $scope.loading = false;

    $scope.project = null;
    const CREDITS_PER_PAGE = 10;
    const BASE_STATE = {
        aspect: "4:5",
        // Measured over six niches: without a limit the model writes a median of 27 words a piece and
        // paragraphs of two sentences. `minimal` leaves a headline and a call to action, `normal` holds
        // each block to one short sentence, and `free` is what everything drawn before this looked like.
        textAmount: "minimal",
        numPages: 1,
        date: null,
        brandingKind: "user",
        // 'image' | 'carousel'
        format: "image",
    };
    const BASE_VIEW = {
        theme: null,
        author: null,
        credits: null,
        summaryCredits: null,
        recording: false,
    };

    $scope.data = angular.copy(BASE_STATE);
    $scope.pallete = [];
    $scope.pages = [];
    $scope.view = angular.copy(BASE_VIEW);

    function reset() {
        $scope.data = angular.copy(BASE_STATE);
        $scope.view = angular.copy(BASE_VIEW);
        $scope.data.brandingKind =
            safeGetStorage("galilai.postgen.brandingKind") || "user";
        $scope.pages = [];
        $scope.activeIndex = null;
        $scope.step = 1;
        $scope.project = null;
        $scope.pallete = [];
    }

    $rootScope.$on("generator.postgen.show", function (event, data) {
        reset();

        api
            .getCurrentCredits()
            .then(function (res) {
                $scope.view.credits = res.data.credits;
                $scope.view.summaryCredits = res.data
                $timeout(angular.noop);
            })
            .catch(function (err) {
                // TODO - ignore
            });
        $scope.view.theme = data.theme || null;
        if ($scope.view.theme && $scope.view.theme.pallete) {
            $scope.pallete = [
                $scope.view.theme.pallete.main,
                $scope.view.theme.pallete.text,
                $scope.view.theme.pallete.highlight,
            ];
            $scope.pallete = $scope.pallete.filter((color) => color);
        }
        if (data.author) {
            $scope.view.author = data.author;
        }
        $scope.project = data.project;
        $scope.data.date = data.date || new Date();
        // The dashboard "create video" button is just a preset of this same modal
        if (data.format) {
            $scope.chooseFormat(data.format);
        }
        angular.element("#postgen-modal").modal("show");
    });

    $rootScope.$on("credits.refresh", function (event) {
        refreshCredits();
    });

    function refreshCredits() {
        api
        .getCurrentCredits()
        .then(function (res) {
            $scope.view.credits = res.data.credits;
            $scope.view.summaryCredits = res.data;
            $timeout(angular.noop);
        })
        .catch(function (err) {
            // TODO - ignore
        });
    }

    $rootScope.$on("credits.updated", function (event, credits) {
        refreshCredits()
    });

    $scope.toggleAccordion = function (index) {
        if ($scope.activeIndex === index) {
            $scope.activeIndex = null;
        } else {
            $scope.activeIndex = index;
        }
    };

    // Both buttons only EXPAND the brief — around twenty-five seconds — and then hand over to the
    // review step or to the editor, which is where the image is actually drawn. So the messages
    // below stay on planning and never claim a piece was rendered: a wait that lies about what it
    // finished is worse than one that says nothing.
    //
    // Until now the panel showed nothing at all: the buttons greyed out and the person waited in
    // front of a still screen, which is how a working request comes to look like a frozen one.
    var ESTIMATED_MS = 25000;
    var MESSAGE_EVERY_MS = 3000;
    var TICK_MS = 250;
    var progressTimer = null;
    var messageTimer = null;

    $scope.progress = { active: false, percent: 0, message: "" };

    function progressMessages() {
        var messages = [];
        for (var i = 1; i <= 8; i++) {
            messages.push(gettext("postgen.progress_" + i));
        }
        return messages;
    }

    function startProgress() {
        var messages = progressMessages();
        var index = 0;
        var startedAt = Date.now();

        $scope.progress = { active: true, percent: 0, message: messages[0] };

        progressTimer = $interval(function () {
            var ratio = (Date.now() - startedAt) / ESTIMATED_MS;
            // Stops short of the end on purpose. The estimate is an average, so a slower request
            // would otherwise sit at 100% with nothing happening — which reads worse than a bar
            // that is still visibly moving.
            $scope.progress.percent = ratio < 1
                ? Math.round(ratio * 90)
                : Math.min(97, 90 + Math.round((ratio - 1) * 6));
        }, TICK_MS);

        messageTimer = $interval(function () {
            index = Math.min(index + 1, messages.length - 1);
            $scope.progress.message = messages[index];
        }, MESSAGE_EVERY_MS);
    }

    function stopProgress() {
        if (progressTimer) { $interval.cancel(progressTimer); progressTimer = null; }
        if (messageTimer) { $interval.cancel(messageTimer); messageTimer = null; }
        $scope.progress.percent = 100;
        // Let the bar reach the end before it disappears, so the last thing seen is completion
        // rather than a block vanishing mid-way.
        $timeout(function () { $scope.progress.active = false; }, 400);
    }

    // Driven from `loading` rather than from each entry point: reviewing, generating and
    // generating straight from step 1 all flip that flag, and three call sites would be three
    // chances to forget one.
    $scope.$watch("loading", function (isLoading, wasLoading) {
        if (isLoading === wasLoading) { return; }
        if (isLoading) { startProgress(); } else if ($scope.progress.active) { stopProgress(); }
    });

    $scope.$on("$destroy", function () {
        if (progressTimer) { $interval.cancel(progressTimer); }
        if (messageTimer) { $interval.cancel(messageTimer); }
    });

    // "Sugerir Ideia": three titles to choose from; picking one drops it into the field.
    //
    // Hidden while the feature is still being worked on, so unrelated fixes can ship without it.
    // Flip to true to bring the button back — the endpoint behind it stays live either way.
    $scope.ideasEnabled = false;

    $scope.ideas = null;
    $scope.suggesting = false;

    $scope.suggestIdeas = function () {
        if ($scope.suggesting) { return; }
        $scope.suggesting = true;
        $scope.ideas = null;
        api
            .suggestIdeas({
                project: $scope.project,
                format: $scope.data.format,
                language: $scope.view?.theme?.language,
            })
            .then(function (res) {
                if (res?.data?.success && res.data.ideas?.length) {
                    $scope.ideas = res.data.ideas;
                } else {
                    showError(gettext("error.generic"));
                }
            })
            .catch(function () {
                showError(gettext("error.generic"));
            })
            .finally(function () {
                $scope.suggesting = false;
                $timeout(angular.noop);
            });
    };

    // Straight into the field, with no second call. The title IS the idea, and expandPrompts
    // turns it into a brief right after — expanding it here would do that work twice.
    $scope.pickIdea = function (idea) {
        $scope.data.prompt = idea.title;
        $scope.ideas = null;
    };

    $scope.dismissIdeas = function () {
        $scope.ideas = null;
    };

    $scope.goToStep2 = function () {
        $scope.loading = true;
        $scope.expandInputs(function (result) {
            if (!result?.success) {
                showError(gettext("error.generic"));
            } else {
                $scope.step = 2;
            }
            $scope.loading = false;
            $timeout(angular.noop);
        });
    };

    $scope.backToStep1 = function () {
        $scope.step = 1;
    };

    $scope.toggleLink = function () {
        alert("Link toggle clicked");
    };
    $scope.toggleImage = function () {
        alert("Image toggle clicked");
    };

    $scope.getPreview = function (text) {
        if (!text) return "Empty...";
        return text.length > 50 ? text.substring(0, 50) + "..." : text;
    };

    $scope.removePage = function (index) {
        if ($scope.pages.length === 1) return;
        $scope.pages.splice(index, 1);

        if ($scope.activeIndex === index) {
            $scope.activeIndex = null;
        } else if ($scope.activeIndex > index) {
            $scope.activeIndex--;
        }
    };

    $scope.duplicatePage = function (index) {
        var copy = angular.copy($scope.pages[index]);
        $scope.pages.splice(index + 1, 0, copy);
        $scope.activeIndex = index + 1;
    };

    $scope.moveUp = function (index) {
        if (index === 0) return;

        var temp = $scope.pages[index - 1];
        $scope.pages[index - 1] = $scope.pages[index];
        $scope.pages[index] = temp;

        $scope.activeIndex = index - 1;
    };

    $scope.moveDown = function (index) {
        if (index === $scope.pages.length - 1) return;

        var temp = $scope.pages[index + 1];
        $scope.pages[index + 1] = $scope.pages[index];
        $scope.pages[index] = temp;

        $scope.activeIndex = index + 1;
    };

    $scope.generateDirect = function () {
        $scope.pages = [
            {
                text: $scope.data.prompt,
                url: $scope.data.url,
                medias: $scope.data.medias || [],
            },
        ];
        $scope.generate();
    };

    $scope.generate = function () {
        function generate() {
            $scope.loading = true;

            let inputs = getFullInputs();

            api
                .createPostContent({
                    project: $scope.project,
                    inputs: inputs,
                    items: $scope.pages.map(function (page) {
                        let row = Object.assign({}, inputs, {
                            prompt: page.text,
                            medias: page.medias || [],
                        });
                        return row;
                    }),
                })
                .then(function (res) {
                    if (res?.data?.success) {
                        $rootScope.$emit("postgen.edit", {
                            postId: res.data.postContent.postId,
                            isNew: true,
                        });
                        angular.element("#postgen-modal").modal("hide");
                    } else {
                        if (res?.data?.error === "no_credits") {
                            $rootScope.$emit("credits.show");
                        } else {
                            showError(gettext("error.generic"));
                        }
                    }
                })
                .catch(function (err) {
                    showError(gettext("error.generic"));
                })
                .finally(function () {
                    $scope.loading = false;
                });
        }

        if ($scope.data.numPages == 1 && $scope.step == 1) {
            $scope.loading = true;
            $scope.expandInputs(function (result) {
                if (result?.success) {
                    generate();
                } else {
                    $scope.loading = false;
                }
            });
        } else {
            generate();
        }
    };

    function getFullInputs() {
        let inputs = JSON.parse(JSON.stringify($scope.data));
        if (
            $scope.data.brandingKind === "user" &&
            $scope?.pallete?.length > 0
        ) {
            inputs.pallete = $scope.pallete;
        } else {
            delete inputs.pallete;
        }

        inputs.name = $scope.view?.author?.name;
        inputs.handle = $scope.view?.author?.handle;

        if (
            $scope.data.brandingKind === "user" &&
            $scope.view.author?.logo?.url
        ) {
            inputs.logo = $scope.view?.author?.logo?.url;
        } else {
            delete inputs.logo;
        }
        delete inputs.medias;
        return inputs;
    }
    $scope.expandInputs = function (cb) {
        let inputs = getFullInputs();

        api
            .expandPrompts(inputs)
            .then(function (res) {
                $scope.pages = res.data.prompts.map(function (prompt, index) {
                    let row = {
                        text: prompt,
                    };
                    row = Object.assign(row, inputs);
                    if ($scope.data.medias && $scope.data.medias.length > index) {
                        row.medias = [$scope.data.medias[index]];
                    }
                    return row;
                });

                if (cb)
                    cb({
                        success: true,
                    });
            })
            .catch(function (err) {
                if (cb)
                    cb({
                        success: false,
                    });
            });
    };

    $scope.chooseTemplate = function () {
        angular.element("#postgen-modal").modal("hide");
        $rootScope.$broadcast("generate.chooseModes");
    };

    $scope.showDesignKindExplainModal = function () {
        angular.element("#design-kind-explain-modal").modal("show");
    };

    $scope.addImage = function () {
        $rootScope.$broadcast("media.show", {
            source: {
                origin: "postgen.create",
            },
            projectId: $scope.project,
            kind: "image",
            openModal: true,
            multiple: true,
        });
    };

    $scope.removeImage = function (index) {
        if ($scope.data.medias && $scope.data.medias.length > index) {
            $scope.data.medias.splice(index, 1);
        }
    };

    $rootScope.$on("media.selected", function (event, medias, source) {
        if (source && source.origin != "postgen.create") {
            return;
        }

        if (medias && medias.length > 0) {
            // Append to existing medias
            if (!$scope.data.medias) {
                $scope.data.medias = [];
            }
            medias = $scope.data.medias.concat(
                medias.map(function (media) {
                    return {
                        url: media.url,
                    };
                })
            );

            let seen = new Set();
            medias = medias.filter(function (media) {
                if (seen.has(media.url)) {
                    return false;
                } else {
                    seen.add(media.url);
                    return true;
                }
            });

            if (medias.length > 3) {
                medias = medias.slice(0, 3);
                showError(gettext("error.max_selected_medias").replace("%s", 3));
            }
            $scope.data.medias = medias;
        }
    });

    $scope.editBranding = function () {
        angular.element("#postgen-modal").modal("hide");
        $rootScope.$emit("tabs.goto.colors");
    };

    $scope.chooseBranding = function (kind) {
        $scope.data.brandingKind = kind;
        safeSetStorage("galilai.postgen.brandingKind", kind);
    };

    $scope.chooseFormat = function (format) {
        $scope.data.format = format;
        if (format !== "carousel") {
            $scope.data.numPages = 1;
        }
        // Size is not forced: video keeps the cover's ratio, so Feed 4:5 and
        // Reels 9:16 both work exactly like they do for images
    };

    $scope.canGenerate = function () {
        return !!($scope.data.prompt && $scope.data.prompt.trim().length > 0);
    };

    $scope.purchaseCredits = function () {
        $rootScope.$emit("credits.show");
    };

    $scope.getCreditsMessage = function () {
        let numPages = $scope.data.numPages || 1;
        if ($scope.pages && $scope.pages.length > 0) {
            numPages = $scope.pages.length;
        }
        let part1 = gettext("postgen.credits_used").replace(
            "%s",
            "<strong>" + numPages * CREDITS_PER_PAGE + "</strong>"
        );
        let part2 = "";
        let currentCredits = $scope.view.credits;
        if (typeof currentCredits == "number") {
            part2 = gettext("postgen.credits_owned").replace(
                "%s",
                "<strong>" + currentCredits + "</strong>"
            );
        }
        let part3 = ''
        // Quebra o saldo em não-bônus + bônus. O não-bônus é derivado do total, e não
        // de `base`: o total tem mais de um balde (cota do plano, saldo comprado) e só
        // `credits - bonus` continua certo se aparecer um balde novo.
        if ($scope.view.summaryCredits?.bonus) {
            const summary = $scope.view.summaryCredits
            part3 = ` (${summary.credits - summary.bonus} + ${summary.bonus} bonus)`
        }
        return part1 + ". " + part2 + part3;
    };

    $scope.getBlockedMessage = function () {
        if (!$scope.view.summaryCredits?.blocked) {
            return "";
        }
        let blockedCredits = $scope.view.summaryCredits?.blocked || 0;
        return gettext("label.bonus_blocked").replace("%s", "<strong>" + blockedCredits + "</strong>");
    };

    const recorder = transcribeService.createRecorder({
        onText: function (text) {
            $scope.data.prompt = text;
        },
        onState: function (state) {
            $scope.view.recording = state.recording;
            $scope.view.transcribing = state.transcribing;
        },
    });

    $scope.transcribe = function () {
        recorder.toggle();
    };

    $scope.stopTranscription = function () {
        recorder.stop();
    };

    $scope.showPlanSelection = function() {
        $rootScope.showUpgrade('credits_bonus', {
            track: false
        })
    }

});
